<template>
  <div id="app">
    <Iridium/>
  </div>
</template>

<script>
import Iridium from './components/iridium.vue'

export default {
  name: 'App',
  components: {
    Iridium
  }
}
</script>

<style lang="scss">
@import './assets/scss/style.scss';
</style>
